import { Spin } from 'antd'
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { useAccountServiceEmailConfirmationEndpoint } from 'src/api/queries'
import { message } from 'src/components'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'

export const ConfirmEmail = () => {
  const { t } = useLocales()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const { isSuccess, isError, isFetched } =
    useAccountServiceEmailConfirmationEndpoint({
      email: searchParams.get('email') ?? '',
      token: searchParams.get('token') ?? '',
      ...(searchParams.get('sendPasswordResetEmail') && {
        shouldSendResetPasswordEmail: true
      })
    })

  useEffect(() => {
    if (isSuccess) message.success(t('auth.confirm_account_success'))

    if (isError) message.error(t('auth.confirm_account_error'))

    if (isFetched) navigate(paths.auth.root)
  }, [isError, isSuccess, isFetched])

  return <Spin fullscreen spinning />
}
